import { render, staticRenderFns } from "./LabeledField.vue?vue&type=template&id=5f508d4a&lang=html"
import script from "./LabeledField.vue?vue&type=script&lang=js"
export * from "./LabeledField.vue?vue&type=script&lang=js"
import style0 from "./LabeledField.vue?vue&type=style&index=0&id=5f508d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports